// extracted by css-extract-rspack-plugin
export default {"skeleton":"t8RlGu","pulse":"WIfJ_r"};